'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForbiddenError = exports.AuthorizationError = exports.TimeoutError = exports.ServerError = exports.FetchError = undefined;

var _FetchError = require('./FetchError');

var _FetchError2 = _interopRequireDefault(_FetchError);

var _ServerError = require('./ServerError');

var _ServerError2 = _interopRequireDefault(_ServerError);

var _TimeoutError = require('./TimeoutError');

var _TimeoutError2 = _interopRequireDefault(_TimeoutError);

var _AuthorizationError = require('./AuthorizationError');

var _AuthorizationError2 = _interopRequireDefault(_AuthorizationError);

var _ForbiddenError = require('./ForbiddenError');

var _ForbiddenError2 = _interopRequireDefault(_ForbiddenError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FetchError = _FetchError2.default;
exports.ServerError = _ServerError2.default;
exports.TimeoutError = _TimeoutError2.default;
exports.AuthorizationError = _AuthorizationError2.default;
exports.ForbiddenError = _ForbiddenError2.default; /**
                                                    * @since 2016-06-05 12:13
                                                    * @author vivaxy
                                                    */


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/errors/index.js
// module id = 226
// module chunks = 0